import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SplashState {
    isMounted: boolean;
  }
  
  const initialState: SplashState = {
    isMounted: true,
  };
  
  const splash = createSlice({
    name: 'splash',
    initialState,
    reducers: {
      setIsMounted: (state, action: PayloadAction<boolean>) => {
        state.isMounted = action.payload;
      }
    },
  });
  
  export const { setIsMounted } = splash.actions;
  const splashReducer = splash.reducer
  export default splashReducer;